import { render, staticRenderFns } from "./administracionRespuesta.vue?vue&type=template&id=02205b01"
import script from "./administracionRespuesta.vue?vue&type=script&lang=js"
export * from "./administracionRespuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports